import { Toast } from 'components/notifications'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

export const ErrorBanner: FC<{
  email: string
  status?: number
}> = ({ email, status }) => {
  const { t } = useTranslation()
  if (!status) return null

  if (status === 409) {
    return (
      <Toast
        content={t(
          'features.usersAdmin.emailAddressAlreadyAssociatedWithAnotherAccount',
          { email },
        )}
        dismissable={false}
        shadow={false}
        title={t('features.usersAdmin.emailAlreadyInUse')}
        variant="alert"
      />
    )
  }

  if (status === 403) {
    return (
      <Toast
        content={t('features.usersAdmin.youAreNotAllowedToCreateUsers')}
        dismissable={false}
        shadow={false}
        title={t('features.usersAdmin.notAllowed')}
        variant="error"
      />
    )
  }

  if (status === 422) {
    return (
      <Toast
        content={t('features.usersAdmin.invalidEmailAddress')}
        dismissable={false}
        shadow={false}
        title={t('features.usersAdmin.invalidEmail')}
        variant="alert"
      />
    )
  }

  return (
    <Toast
      content={t('features.usersAdmin.failedToCreateUser')}
      dismissable={false}
      shadow={false}
      title={t('features.usersAdmin.unableToCreateUser')}
      variant="error"
    />
  )
}
